export const ActionSetActiveStep = '[Tooltip Component] Set the next active step';
